import { Pipe, PipeTransform } from "@angular/core";
import moment from "moment";
import { TimeFormat, TIME_FORMAT_H12, TIME_FORMAT_H24 } from "types";
import { timeFormatToMomentTimeFormat } from "../utils/time-format-to-moment-time-format";

@Pipe({
  name: "formatTime",
  standalone: true,
})
export class FormatTimePipe implements PipeTransform {
  transform(value: string | moment.Moment | null | undefined, timeFormat: TimeFormat): string {
    if (!value) {
      return "";
    }

    let time: moment.Moment;

    if (typeof value === "string") {
      // Parse the time string and format it according to timeFormat
      time = moment(value, [TIME_FORMAT_H24, TIME_FORMAT_H12]);
    } else {
      // It's already a moment object
      time = value;
    }

    return time.format(timeFormatToMomentTimeFormat(timeFormat));
  }
}
